import cookie from 'js-cookie';
import { oidc as oidcUtils } from '@clubmed/utils';
import { USER_INFO } from 'Utils/ple-utils/cookies';
import createAction from 'Store/utils/createAction';

export const PROFILE_CHANGED = 'PLE_PROFILE_CHANGED';

function refreshCookie({ firstName, lastName, unicodeFirstName, unicodeLastName }) {
  cookie.set(
    USER_INFO,
    oidcUtils.toUriEncodedState({ firstName, lastName, unicodeFirstName, unicodeLastName }),
  );
}

export default function notifyProfileChanged(newProfile) {
  refreshCookie(newProfile);
  return createAction(PROFILE_CHANGED, newProfile);
}
